module.exports = __webpack_public_path__ + "static/media/facebook-logo.de5708ea.svg";